import styles from "../styles/imageScaleAndCrop.module.css";

export const ControlButton = (props: any) => {
  const { children, tooltip = "", ...buttonProps } = props;
  return (
    <button
      data-tip={tooltip}
      data-effect="solid"
      data-place="bottom"
      data-background-color="#6d28d9"
      className={styles.controlButton}
      {...buttonProps}
    >
      {children}
    </button>
  );
};
